export default class MobileMenu {
  constructor() {
    // Základní elementy
    this.toggleButton = document.getElementById("mobile-nav-toggle");
    this.body = document.body;

    // Pokud nenajdeme toggle button, není třeba pokračovat
    if (!this.toggleButton) return;

    // Inicializace
    this.isOpen = false;
    this.init();
  }

  init() {
    // Přidání click event listeneru
    this.toggleButton.addEventListener("click", () => this.toggleMenu());
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;

    // Přepnutí aria-expanded atributu
    this.toggleButton.setAttribute("aria-expanded", this.isOpen);

    // Přidání/odebrání třídy pro otevřené menu
    this.body.classList.toggle("menu-is-open");

    console.log("toggled ");
  }
}
